import React, { useEffect, useRef, useState } from 'react'
import {Steps, Radio, Menu, Layout, message,Col, Row, Pagination, Button, Input, Modal, ConfigProvider,} from 'antd'
import { BulbOutlined, CheckCircleOutlined, SearchOutlined, TeamOutlined } from '@ant-design/icons'
import projectDetailStyles from './project-detail.module.less'
import projectStyles from './project.module.less'
import zhCN from 'antd/lib/locale/zh_CN'
import { checkUserLogin } from '../common/user-center/user-info'

import classempty from '../../static/image/noclassroom.png'
import teacher from '../../static/image/teacher.png'
import student from '../../static/image/student.png'
import lead0 from '../../static/image/lead0.svg'
import lead1 from '../../static/image/lead1.svg'
import lead2 from '../../static/image/lead2.svg'


import 'easymde/dist/easymde.min.css'
import ReactMarkdown from 'react-markdown'
import rehypeKatex from 'rehype-katex'
import 'katex/dist/katex.min.css' // `rehype-katex` does not import the CSS for you
import gfm from 'remark-gfm'
import remarkMath from 'remark-math'
import rehypeRaw from 'rehype-raw'
import rehypeHighlight from 'rehype-highlight'
import Draggable from 'react-draggable'
import { sendHttpPostRequest } from '../../api/http-request'
import Cookies from 'js-cookie'
import PageHeader from '../common/page-header/header'
import PageFooter from '../common/page-footer/footer'
// import Feedback from '../common/feedback-help/feedback'
import { BACKEND_API_URL } from '@/constants/constants'
import CoursePaymentModal from './components/CoursePaymentModal'

const { SubMenu } = Menu
const { Step } = Steps

export const BrainIcon = () => (
<svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"  width="20" height="20">
  <path d="M368 0c61.8 0 112 50.2 112 112v800c0 61.8-50.2 112-112 112-57.8 0-105.4-43.8-111.4-100.2-10.4 2.8-21.4 4.2-32.6 4.2-70.6 0-128-57.4-128-128 0-14.8 2.6-29.2 7.2-42.4C42.8 734.8 0 676.4 0 608c0-63.8 37.4-119 91.6-144.6C74.2 441.6 64 414 64 384c0-61.4 43.2-112.6 100.8-125.2C161.6 247.8 160 236 160 224c0-59.8 41.2-110.2 96.6-124.2 6-56 53.6-99.8 111.4-99.8z m288 0c57.8 0 105.2 43.8 111.4 99.8C823 113.8 864 164 864 224c0 12-1.6 23.8-4.8 34.8 57.6 12.4 100.8 63.8 100.8 125.2 0 30-10.2 57.6-27.6 79.4 54.2 25.6 91.6 80.8 91.6 144.6 0 68.4-42.8 126.8-103.2 149.6 4.6 13.2 7.2 27.6 7.2 42.4 0 70.6-57.4 128-128 128-11.2 0-22.2-1.4-32.6-4.2-6 56.4-53.6 100.2-111.4 100.2-61.8 0-112-50.2-112-112V112c0-61.8 50.2-112 112-112z"  fill="#9333ea">

  </path>
  </svg>
);

export const TargetIcon = () => (
  <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"  width="24" height="24"><path d="M512 512m-85.333333 0a85.333333 85.333333 0 1 0 170.666666 0 85.333333 85.333333 0 1 0-170.666666 0Z" fill="#4f46e5"></path><path d="M512 768c-140.8 0-256-115.2-256-256s115.2-256 256-256 256 115.2 256 256-115.2 256-256 256z m0-426.666667c-93.866667 0-170.666667 76.8-170.666667 170.666667s76.8 170.666667 170.666667 170.666667 170.666667-76.8 170.666667-170.666667-76.8-170.666667-170.666667-170.666667z" fill="#4f46e5"></path><path d="M512 938.666667C277.333333 938.666667 85.333333 746.666667 85.333333 512S277.333333 85.333333 512 85.333333s426.666667 192 426.666667 426.666667-192 426.666667-426.666667 426.666667z m0-768c-187.733333 0-341.333333 153.6-341.333333 341.333333s153.6 341.333333 341.333333 341.333333 341.333333-153.6 341.333333-341.333333-153.6-341.333333-341.333333-341.333333z"  fill="#4f46e5"></path></svg>
);

export const BasicIcon = () => (
<svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"  width="20" height="20"><path d="M613.664 819.68a16.32 16.32 0 0 1-4.688-0.704l-476.96-146.24c-11.744-2.064-69.248-17.328-69.248-118.176 0-46.32 18.336-71.664 33.696-84.752 21.856-18.624 53.68-26.224 87.344-20.768a16 16 0 0 1-5.088 31.584c-24.384-3.936-46.8 1.008-61.504 13.536-14.896 12.688-22.448 33.008-22.448 60.4 0 81.344 42.064 86.592 42.48 86.624 1.04 0.112 2.064 0.32 3.056 0.624L608 785.2 926.448 392c-4.96-13.664-9.184-39.216 3.584-78.144a16.016 16.016 0 0 1 30.416 9.968c-13.888 42.368-2.24 61.024-2.112 61.216 3.776 5.808 3.696 13.872-0.656 19.264l-331.584 409.44a15.936 15.936 0 0 1-12.432 5.936z" fill="#4f46e5"></path><path d="M613.664 1016.896c-1.632 0-3.264-0.256-4.88-0.768L130.752 863.232c-3.072-1.024-67.984-24.352-67.984-123.552 0-61.008 45.12-97.616 47.04-99.12a15.984 15.984 0 1 1 19.92 25.024c-0.304 0.256-34.96 28.848-34.96 74.096 0 76.56 45.568 93.008 46.032 93.168l467.392 149.488 318.272-387.728c-11.424-26.8-35.952-104 3.872-206.192a16.016 16.016 0 0 1 29.808 11.632c-43.296 111.104-1.376 188.32-0.944 189.072 3.2 5.744 2.576 12.88-1.6 17.968L626.032 1011.04a16 16 0 0 1-12.368 5.856z" fill="#4f46e5" ></path><path d="M982.624 155.008a35.568 35.568 0 0 0-26.16-23.152L463.376 20.08a36.048 36.048 0 0 0-34.56 11.616L76.624 423.664c-8.096 9.184-37.248 50.784-37.248 113.504 19.664-24.336 43.088-58.88 54.976-55.68l484.336 146.112a35.792 35.792 0 0 0 36.896-11.84l360.96-426.336a35.776 35.776 0 0 0 6.08-34.416z m-263.44 84.272l-27.152 32.16c-7.536 8.88-25.024 13.296-38.96 10.032l-252.8-61.632c-13.92-3.344-19.184-13.344-11.728-22.16l27.152-32.256c7.504-8.864 25.008-13.28 38.976-9.968l252.816 61.504c13.856 3.36 19.168 13.424 11.696 22.32z" fill="#4f46e5" ></path></svg>
);
export const ToolsIcon = () => (
<svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"  width="20" height="20"><path d="M940.3 755.9L735.4 551.2C695 510.9 634.6 503 585.9 526.9L399.4 340.6V232l-224-167.8-112 111.9 168 223.8h108.7l186.5 186.3c-23.8 48.6-16.1 108.9 24.3 149.3l204.9 204.7c25.5 25.5 66.8 25.5 92.2 0l92.2-92.1c25.5-25.6 25.5-66.8 0.1-92.2zM643.9 457.5c49.5 0 96.1 19.2 131.1 54.2l33.9 33.9c27.6-12.1 53.9-28.8 76.6-51.6 64.9-64.9 87-156.1 66.3-239-3.8-15.7-23.6-21.2-35.2-9.6L786.5 375.6l-118.8-19.8-19.8-118.7L778.1 107c11.5-11.5 5.9-31.3-10-35.3-82.9-20.5-174.3 1.6-239 66.3-49.9 49.8-73.3 115.5-72.1 181.1l143.7 143.5c14.1-3.3 28.8-5.1 43.2-5.1zM462 600.9l-99.2-99.1L96.1 768.4c-43.7 43.7-43.7 114.5 0 158.2s114.6 43.7 158.4 0l216.3-216.1c-13.3-34.8-17.3-72.7-8.8-109.6zM175.4 889.3c-23.1 0-42-18.9-42-42 0-23.2 18.7-42 42-42s42 18.7 42 42c0 23.1-18.7 42-42 42z"  fill="#16a34a"></path></svg>
);

export const InfoIcon = () => (
<svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"  width="30" height="30"><path d="M512 85.333333a426.666667 426.666667 0 1 0 426.666667 426.666667A426.666667 426.666667 0 0 0 512 85.333333z m42.666667 597.333334a42.666667 42.666667 0 0 1-85.333334 0v-213.333334a42.666667 42.666667 0 0 1 85.333334 0z m-42.666667-298.666667a42.666667 42.666667 0 1 1 42.666667-42.666667 42.666667 42.666667 0 0 1-42.666667 42.666667z" fill="#54bfbf"></path></svg>

  );

export const MenuIcon = () => (
  <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"  width="30" height="30"><path d="M895.108956 191.933357 381.95876 191.933357c-35.147498 0-63.642482 28.493961-63.642482 63.643506 0 35.147498 28.494984 63.642482 63.642482 63.642482l513.150196 0c35.149545 0 63.642482-28.494984 63.642482-63.642482C958.751439 220.427318 930.257477 191.933357 895.108956 191.933357z" fill="#4f46e5"></path><path d="M895.108956 449.806519 381.95876 449.806519c-35.147498 0-63.642482 28.493961-63.642482 63.643506 0 35.148521 28.494984 63.642482 63.642482 63.642482l513.150196 0c35.149545 0 63.642482-28.494984 63.642482-63.642482C958.751439 478.30048 930.257477 449.806519 895.108956 449.806519z"  fill="#4f46e5"></path><path d="M893.062344 703.58748 379.912148 703.58748c-35.147498 0-63.642482 28.493961-63.642482 63.642482 0 35.148521 28.494984 63.642482 63.642482 63.642482l513.150196 0c35.149545 0 63.642482-28.494984 63.642482-63.642482C956.704826 732.080417 928.210865 703.58748 893.062344 703.58748z" fill="#4f46e5"></path><path d="M130.647037 257.025864m-61.398372 0a60 60 0 1 0 122.796744 0 60 60 0 1 0-122.796744 0Z"  fill="#4f46e5"></path><path d="M124.5072 514.899026m-61.398372 0a60 60 0 1 0 122.796744 0 60 60 0 1 0-122.796744 0Z"  fill="#4f46e5"></path><path d="M126.553813 766.632351m-61.398372 0a60 60 0 1 0 122.796744 0 60 60 0 1 0-122.796744 0Z"  fill="#4f46e5"></path></svg>
  );

export const TeachingIcon = () => (
  <svg  viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"  width="18" height="18"><path d="M317.09108148 322.06696297c0 94.66311111 76.70139259 171.3645037 171.3645037 171.3645037 94.66311111 0 171.3645037-76.70139259 171.36450371-171.3645037s-76.70139259-171.3645037-171.36450371-171.36450372c-94.66311111 0-171.3645037 76.70139259-171.3645037 171.36450372z m0 0M1008.13179259 435.6626963c-10.19448889-10.19448889-26.82121482-10.19448889-37.0157037 0L686.76266667 719.89475555c-2.18453333 2.18453333-3.88361482 4.97588148-5.09724445 7.64586667-0.36408889 0-0.60681482 0.12136297-0.9709037 0.12136296-0.36408889 0-0.72817778-0.12136297-0.9709037-0.12136296-10.43721482 8.61677037-25.60758518 7.76722963-35.19525927-1.69908147-10.19448889-10.19448889-10.19448889-26.82121482 0-37.01570372l84.2258963-84.22589628c-35.80207408-35.31662222-82.16272592-61.65238518-134.47016296-75.3664l-74.51685926 74.51685925-28.03484445 107.64894815c-0.60681482 1.69908148-5.33997037 1.69908148-5.94678518 0L458.72165925 607.87674075l-78.03638517-78.0363852C260.17185185 562.24426667 172.1837037 662.61143703 172.1837037 781.54714075v48.66654814c0 23.9085037 21.48124445 43.20521482 48.05973333 43.20521481h62.13783705v-82.16272592c0-7.76722963 6.31087408-14.19946667 14.19946667-14.19946667 7.76722963 0 14.19946667 6.31087408 14.19946666 14.19946667v82.16272592h446.6157037c26.57848889 0 48.05973333-19.41807408 48.05973334-43.20521481v-48.66654814c0-31.19028148-6.43223703-60.92420741-17.47626667-88.59496297l220.63786667-220.63786667c9.70903703-9.8304 9.70903703-26.45712592-0.48545186-36.65161481z m0 0" fill="#ffffff"></path></svg>
  );

export const CodingIcon = () => (
  <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"  width="18" height="18"><path d="M489.6 723.2a41.6 41.6 0 0 1-41.6-41.6 41.6 41.6 0 0 1 41.6-41.6h300.8a41.6 41.6 0 0 1 41.6 41.6 41.6 41.6 0 0 1-41.6 41.6z m-316.736-64.384a44.288 44.288 0 0 1 0-62.4l135.04-135.104-129.792-129.664a44.352 44.352 0 0 1 0-62.464 44.8 44.8 0 0 1 32-13.184 44.8 44.8 0 0 1 32 13.184l160.896 160.96a44.032 44.032 0 0 1 12.8 31.168 44.352 44.352 0 0 1-12.8 31.296l-166.4 166.4a44.8 44.8 0 0 1-32 13.184 44.8 44.8 0 0 1-31.808-13.376z" fill="#ffffff" ></path></svg>
);
  
export const PlayIcon = () => (
<svg  viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"  width="24" height="24"><path d="M510.3 98.2c-229.2 0-415.1 185.8-415.1 415S281 928.3 510.3 928.3s415.1-185.8 415.1-415.1c0-229.2-185.9-415-415.1-415z m163.8 448.1L446.5 679.1c-3.3 1.9-6.7 2.8-10.1 2.8-10.5 0-20.1-8.4-20.1-20.1V396.2c0-11.7 9.6-20.1 20.1-20.1 3.4 0 6.8 0.9 10.1 2.8l227.6 132.8c13.3 7.7 13.3 26.9 0 34.6z" fill="#ffffff"></path></svg> 

);
export interface Props {}

export const ProjectDetail: React.FC<Props> = (props) => {

  const ENV = process.env

  let location = window.location
  let projectId = parseInt(window.location.search.split('=')[1]) // 项目的ID
  if (!projectId) {
    projectId = 1
  }

  const [collegeId, setCollegeId] = useState(null as any) // 院校ID
  const [collegeInfo, setCollegeInfo] = useState(null as any) //查询当前用户的机构信息,is_college_teacher weitrue表示是教师，
  const [project, setProject] = useState(null as any)
  const currentClassRoomId = useRef(null as any) //当前点击的教室ID

  const [inClassVisible, setInClassVisible] = useState(false) //教室选择弹出框

  const pageClassRoom = useRef(1) // 记录当前的页数
  const pageSizeClassRoom = useRef(9) // 记录当前每页展示数量
  const [resultSumClassRoom, setResultSumClassRoom] = useState(null as any)
  const [projectClassRoomList, setProjectClassRoomList] = useState(null as any) //保存教室查询列表
  const queryClassRoom = useRef('') //教室查询

  const [openkeys, setOpenKeys] =  useState(null) //展开大纲

  const [userInfo, setUserInfo] = useState(null as any) //当前用户的信息
  const [realName, setRealName] = useState(null as any) //保存当前学生真实姓名
  const [realNumber, setRealNumber] = useState(null as any) //学号


  const selectedClassRoomId = useRef(null as any) //当前选中的教室ID
  const [selectedClassRoom, setSelectedClassRoom] = useState(null as any) //当前选中的教室
  const inputClassRoomPassword = useRef(null as any) //当前用户输入的教室密码


  const [applyNumberVisible, setApplyNumberVisible] = useState(false) //申请院校码弹出框
  const [applySubmitVisible, setApplySubmitVisible] = useState(false) //申请提交弹出框
  const [joinVisible, setJoinVisible] = useState(false) //提示加入院校弹出框
  const [notPurchasedVisible, setNotPurchasedVisible] = useState(false) //未购买提示框
  const [delayVisible, setDelayVisible] = useState(false) //延期提示框
  const [notOnlineVisible, setNotOnlineVisible] = useState(false) //未上线提示框
  const [coursePaymentVisible, setCoursePaymentVisible] = useState(false)
  const [accessPromptMessage, setAccessPromptMessage] = useState('')
  const [salesContact, setSalesContact] = useState('136 9329 0406')

  const [
    inputClassPasswordModalVisible,
    setInputClassPasswordModalVisible,
  ] = useState(false) //输入教室密码弹出框
  const [joinClassError, setJoinClassError] = useState('')  // 加入班级内联错误提示


  const [current, setCurrent] = React.useState(0)

  const draggleRef = useRef<HTMLDivElement | null>(null)

  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
  const [disabled, setDisabled] = useState(true)
  const lastEnterContextRef = useRef({
    isInCollege: false,
    isCollegeTeacher: false,
    projectId: projectId,
  })
  
  const onStart = (event: any, uiData: any) => {
    const { clientWidth, clientHeight } = window?.document?.documentElement
    const targetRect = draggleRef?.current?.getBoundingClientRect()
    if (targetRect) {
      setBounds({
        left: -targetRect?.left + uiData?.x,
        right: clientWidth - (targetRect?.right - uiData?.x),
        top: -targetRect?.top + uiData?.y,
        bottom: clientHeight - (targetRect?.bottom - uiData?.y),
      })
    }
  }


  const steps = [
    
    {
      title: '获取院校码',
      content: (
        <div style={{ textAlign: 'center' }}>
          <div
            style={{
              textAlign: 'left',
              color: '#000',
              margin: '10px 0',
              paddingLeft: 10,
            }}
          >
            院校码示意图：
          </div>
          <Row style={{ color: '#333' }}>
            <Col span={12} style={{ textAlign: 'center' }}>
              <div className={projectStyles.collegeNum}>
                <img
                  src={teacher}
                  width={60}
                  height={60}
                  style={{ marginTop: -20 }}
                />
                <div
                  style={{
                    textAlign: 'left',
                    marginTop: 10,
                    display: 'inline-block',
                  }}
                >
                  教师码
                  <br />
                  XLJBLERK
                </div>
              </div>
            </Col>
            <Col span={12} style={{ textAlign: 'center' }}>
              <div className={projectStyles.collegeNum}>
                <img
                  src={student}
                  width={60}
                  height={60}
                  style={{ marginTop: -20 }}
                />
                <div
                  style={{
                    textAlign: 'left',
                    marginTop: 10,
                    display: 'inline-block',
                  }}
                >
                  学生码
                  <br />
                  XDCFVJGF
                </div>
              </div>
            </Col>
          </Row>
          <div
            style={{
              textAlign: 'left',
              color: '#000',
              margin: '10px 0',
              marginLeft: 10,
            }}
          >
            如无院校码，请点击菜单上方的获取院校码按钮
          </div>
          <img src={lead0} width={450} height={130} alt="" />
        </div>
      ),
    },
    {
      title: '填写院校码',
      content: (
        <div style={{ textAlign: 'center', marginTop: 10 }}>
          <div
            style={{
              textAlign: 'left',
              color: '#000',
              margin: '6px 0',
              marginLeft: 10,
            }}
          >
            在个人中心填写院校码，点击提交
          </div>
          <img src={lead1} width={400} height={250} alt="" />
        </div>
      ),
    },
    {
      title: '完成认证',
      content: (
        <div style={{ textAlign: 'center', marginTop: 10 }}>
          <div
            style={{
              textAlign: 'left',
              color: '#000',
              margin: '6px 0',
              marginLeft: 10,
            }}
          >
            个人中心显示院校即为认证成功
          </div>
          <img src={lead2} width={400} height={250} alt="" />
        </div>
      ),
    },
  ]


  useEffect(() => {
    queryProject()
    queryCollegeInfo()
  }, [])

  /**
   * 查询项目
   */
  const queryProject = () => {
    sendHttpPostRequest(
      'course/api/query_project_detail_by_id',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        project_id: projectId,
      },
      queryProjectCallback
    )
  }


    /**
   * 获取机构和身份信息
   */
    const queryCollegeInfo = () => {
      sendHttpPostRequest(
        //获取院校身份信息
        'account/api/query_teacher_authenticate',
        {
          sessionid: Cookies.get('sessionid'),
          sid: Cookies.get('sessionid'),
        },
        (response: any) => {
          if (response.is_ok == true) {
            if (response?.college_id > 0) {
              //已加入机构
              let _collegeId = response.college_info.college_id
              setCollegeId(_collegeId)
              setCollegeInfo(response.college_info)
            }
          }
        }
      )
    }


      // 保存用户信息回调
  const saveUserInfoCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      document.getElementById('show-login-modal')!.click()
    } else if (response.code == 0) {
      message.success('更新用户信息成功')
      // 重设localStorage
      //queryUserInfo();
      sendHttpPostRequest(
        'classroom/api/user_add_classroom',
        {
          sessionid: Cookies.get('sessionid'),
          classroom_id: selectedClassRoomId.current,
          password: inputClassRoomPassword.current,
        },
        (response: any) => {
          message.destroy()
          if (response.code == -100) {
            // 未登录
            document.getElementById('show-login-modal')!.click()
          } else if (response.is_ok == true) {
            message.success('加入教室成功~')
            window.location.href =
              '/project_main_student?project_id=' + projectId
          } /*else if (response.code == -501) {
                            权限不足
                            window.location.href = '/oam_login?next=oam_menu';
                        } */ else {
            setJoinClassError(response.message || '加入班级失败，请重试')
          }
        }
      )
    } else {
      setJoinClassError(response.message || '保存用户信息失败，请重试')
    }
  }

      // 保存用户信息
  const saveUserInfo = () => {
    sendHttpPostRequest(
      'account/api/update_user_info/',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        user_id: userInfo?.user_id,
        real_name: realName,
        number: realNumber,
        nick_name: userInfo?.nick_name,
      },
      saveUserInfoCallback
    )
  }

      //教室页码和页数发生了变化
  const onClassRoomPageChange = (
    newPage: number,
    newPageSize?: number | undefined
  ) => {
    pageClassRoom.current = newPage ? newPage : 1
    if (newPageSize) {
      pageSizeClassRoom.current = newPageSize
    }
    queryProjectClassRoomList(projectId, collegeId, false)
  }

  /** 学生加入某个班级 */
  const onConfirmInputClass = () => {
    setJoinClassError('')
    if (realName?.trim() == '') {
      setJoinClassError('真实姓名不能为空~')
      return ''
    }

    if (realNumber?.trim() == '') {
      setJoinClassError('学号不能为空~')
      return ''
    }

    saveUserInfo()
  }

  /** 查询当前学生所在机构的某个项目的所有教师列表 */
  const queryProjectClassRoomList = (projectId, collegeID, showModal) => {
    sendHttpPostRequest(
      'classroom/api/user_query_classroom_list/',
      {
        sessionid: Cookies.get('sessionid'),
        course_id: projectId,
        college_id: collegeID,
        query: queryClassRoom.current,
        page: pageClassRoom.current,
        pagesize: pageSizeClassRoom.current,
      },
      (response: any) => {
        // console.log(response)
        message.destroy()
        if (response.code == -100) {
          // 未登录
          document.getElementById('show-login-modal')!.click()
        } else if (response.is_ok == true) {
          setProjectClassRoomList(response.query_list)
          setResultSumClassRoom(response.total_sum)

          if (showModal == true) {
            setInClassVisible(true)
          }
        } /*else if (response.code == -501) {
                    权限不足
                    window.location.href = '/oam_login?next=oam_menu';
                } */ else {
          message.error(response.message)
        }
      }
    )
  }


  // 从菜单数据中构造
  const constructMenu = () => {
    return  <Menu defaultOpenKeys={openkeys} mode="inline">
              { project?.menu?.map((chapter, chapterInd) => {
                return <SubMenu style={{ fontSize: 18, fontWeight:600 }} key={'chapter_' + chapter.id} title={<span > {String(chapterInd + 1) + '. ' + chapter.name}</span>}>
                  {chapter.tasks?.map((node, nodeInd) => {
                      return <Menu.Item key={'node_' + node.id} style={{ fontSize: 16,fontWeight:'normal' }}>
                      <a
                        href={'#' + 'node_' + node.id}
                        style={{cursor:'text'}}
                       
                      >

                                  {String(chapterInd + 1) +'.' +String(nodeInd + 1) +' ' + node.name}
                      </a>
                    </Menu.Item>
                  })}
                </SubMenu>
              }) }
    </Menu>
  }

  /**
   * 查询项目回调
   * @param response
   */
  const queryProjectCallback = (response: any) => {
    message.destroy()
    if (response.is_ok == true) {
      // 成功
      setProject(response.query_info)
      const _salesContact = response?.query_info?.access_info?.sales_contact
      if (_salesContact) {
        setSalesContact(_salesContact)
      }
      const openkeys_ = response.query_info?.menu?.map((chapter, chapterInd) => {return 'chapter_' + chapter.id})
      setOpenKeys(openkeys_)
    }else {
      message.error(response.message)
    }
  }

    // 点击开始实训按钮
    const onProjectLoginClick = (
      isInCollege: boolean,
      isCollegeTeacher: boolean,
      projectId: number,
    ) => {
        lastEnterContextRef.current = {
          isInCollege,
          isCollegeTeacher,
          projectId,
        }
      message.destroy()
      console.log(isInCollege)
      console.log(isCollegeTeacher)
      if (!checkUserLogin()) {
        // 未登录先登录
        document.getElementById('show-login-modal')!.click()
      } else {
        const accessInfo = project?.access_info || {}
        const canAccess = accessInfo?.can_access == true

        //检查项目是否购买或者是否已经过期
        if (project?.public_status == 2) {
          setNotOnlineVisible(true)
        } else if (!canAccess) {
          const payReason = accessInfo?.pay_reason
          if (payReason == 'college_or_course_expired') {
            setAccessPromptMessage('机构授权已过期，可联系销售续约机构，或个人付费继续使用。')
            setDelayVisible(true)
          } else if (payReason == 'college_course_unconfigured') {
            setAccessPromptMessage('机构尚未配置该项目，请联系机构管理员/工作人员开通，或个人付费继续使用。')
            setNotPurchasedVisible(true)
          } else {
            setAccessPromptMessage('你可以先加入机构使用机构授权，也可以个人付费继续使用。')
            setNotPurchasedVisible(true)
          }
        } else {
          const payReason = project?.access_info?.pay_reason
          if (payReason === 'teacher_bypass' && isCollegeTeacher) {
            // 机构授权有效的教师：进教师页
            window.open('/project_main?project_id=' + projectId)
          } else if (payReason === 'personal_paid') {
            // 个人付费（包括教师个人付费）：进学生页
            window.open('/project_main_student?project_id=' + projectId)
          } else if (isInCollege == true && isCollegeTeacher == true) {
            window.open('/project_main?project_id=' + projectId)
          } else if (
            isInCollege == true &&
            isCollegeTeacher == false &&
            project.in_classroom == 1
          ) {
            window.open('/project_main_student?project_id=' + projectId)
            window.name = 'project_main_student'
          } else if (
            isInCollege == true &&
            isCollegeTeacher == false &&
            project.in_classroom == 0
          ) {
            //机构学生尚未加本项目教室
            queryProjectClassRoomList(projectId, collegeId, true)
          } else {
            // 未加机构但 canAccess
            window.open('/project_main_student?project_id=' + projectId)
          }
        }
      }
    }

  const onCoursePaymentSuccess = () => {
    setCoursePaymentVisible(false)
    message.success('支付成功，正在刷新权限...')
    queryProject()
    setTimeout(() => {
      const ctx = lastEnterContextRef.current
      onProjectLoginClick(ctx.isInCollege, ctx.isCollegeTeacher, ctx.projectId)
    }, 1000)
  }

    


  return (
    <Layout style={{ backgroundColor: '#f9f9f9',minHeight: 820}}>

      <PageHeader keys={[]} />
      <div className={projectDetailStyles.pageMain}>
        <div className={projectDetailStyles.projectMain}>
          <div id="title" className={projectDetailStyles.topTitle} >
            <div className={projectDetailStyles.projectName} >
            {project?.name}
            </div>

            <Row justify="space-around" align="middle" wrap={false} style={{height:120}}>
              <Col flex="auto" >
                <div className={projectDetailStyles.aimContentText}  title={project?.aim} >
                  {project?.aim}
                </div>

                </Col>
              <Col flex="130px"> 
                <div className={projectDetailStyles.beginTraining} style={{cursor:'pointer', fontWeight:600, textAlign:'center', borderRadius:24, fontSize:18, padding:"8px 12px", color:'#fff'}} > 
                
                  <Row align="middle" 
                     onClick={() => {
                      onProjectLoginClick(
                        collegeId !== 0 &&
                          collegeId !== null &&
                          collegeId !== '',
                        collegeInfo?.is_college_teacher == 1,
                        project.id,
                      )
                    }}
                    >
                    <Col style={{height: 24, marginRight:2}} > <PlayIcon /> </Col>
                    <Col style={{height: 24, lineHeight:"24px"}} >开始实训</Col>
                  </Row>
                 </div>
              </Col>
            </Row>

            <div style={{display:'flex'}}>
                  <Row align="middle" style={{marginRight:10,borderRadius:16, background:'#ffffff33',  height:32, fontWeight:500, fontSize:14, lineHeight:'20px', color:'#fff', padding:'6px 16px'}}> 
                    <Col style={{height: 18,marginRight:2}} > <TeachingIcon /></Col>
                    <Col style={{height: 18,lineHeight:"18px"}} >教学课时 {project?.teaching_duration} </Col>
                  </Row>

                  <Row align="middle" style={{marginRight:10,borderRadius:16, background:'#ffffff33',  height:32, fontWeight:500, fontSize:14, lineHeight:'20px', color:'#fff', padding:'6px 16px'}}> 
                    <Col style={{height: 18,marginRight:2}}  > <CodingIcon /></Col>
                    <Col style={{height: 18, lineHeight:"18px"}}  > 实训课时 {project?.practice_duration} </Col>
                  </Row>
                </div>
          

          </div>
          <div id="basic" className={projectDetailStyles.aim}>
            <Row gutter={48}>
              <Col span={8}>
                <div className={projectDetailStyles.aimDiv}>
                  <div className={projectDetailStyles.aimHeader}>
                    <div  style={{padding:12, color:'#4f46e5', backgroundColor:'#eef2ff'}} className={projectDetailStyles.aimHeaderLogoDiv}>  
                    <BasicIcon />
                    </div> 
                     前置基础</div>
                  <div  className={projectDetailStyles.aimContent}>
                      <Row
                      wrap={true}
                      align="middle"
                      justify="start"
                      gutter={[12, 12]}
                      style={{ width: '100%', overflow: 'hidden' }}
                    >
                      {project?.preconditions?.split(';')?.map((skill, skillInd) => {
                        return (
                          <Col key={skillInd} className={projectDetailStyles.label} title={skill}>
                            {skill}
                          </Col>
                        )
                      })}
                    </Row>
                   
                    
                  </div>
                </div>
              </Col>


              <Col span={8}>
              <div className={projectDetailStyles.aimDiv}>
                  <div className={projectDetailStyles.aimHeader}> 
                    <div  style={{color:'#9333ea', backgroundColor:'#f3e8ff'}} className={projectDetailStyles.aimHeaderLogoDiv}>  
                    <BrainIcon />
                    </div> 
                    锻炼能力</div>
                  <div className={projectDetailStyles.aimContent} > 
                    <Row
                        wrap={true}
                        align="middle"
                        justify="start"
                        gutter={[12, 12]}
                        style={{ width: '100%', overflow: 'hidden' }}
                      >
                        {project?.ability?.split(';')?.map((skill, skillInd) => {
                          return (
                            <Col key={skillInd} className={projectDetailStyles.label} title={skill}>
                              {skill}
                            </Col>
                          )
                        })}
                      </Row>
                   
 
                  </div>
                </div>
              </Col>

              <Col span={8}>
                <div className={projectDetailStyles.aimDiv}>
                  <div className={projectDetailStyles.aimHeader}>
                    <div  style={{color:'#16a34a', backgroundColor:'#dcfce7'}} className={projectDetailStyles.aimHeaderLogoDiv}>  
                    <ToolsIcon />
                    </div>  
                    实践工具</div>
                  <div className={projectDetailStyles.aimContent} > 
                    <Row
                        wrap={true}
                        align="middle"
                        justify="start"
                        gutter={[12, 12]}
                        style={{ maxHeight:120,width: '100%', overflow: 'hidden' }}
                      >
                        {project?.tools?.split(';')?.map((tool, toolInd) => {
                          return (
                            <Col key={toolInd} className={projectDetailStyles.label} title={tool}>
                              {tool}
                            </Col>
                          )
                        })}
                      </Row>
                  
                   
                  </div>
                </div>
              </Col>


            </Row>
          
          </div>
          <div id="description" className={projectDetailStyles.description}>
            <div style={{marginBottom: 24, display:'flex', }}>
            <div style={{display:'flex', height:30, marginRight:16,padding:0, width:30}} className={projectDetailStyles.aimHeaderLogoDiv}>  
                    <InfoIcon />
                    </div> 
            
             
              <span style={{fontSize: 24, lineHeight:'30px', fontWeight:700, color:'#1f2937'}}>项目介绍</span>
            </div>
            <div >
              <ReactMarkdown
                className={projectDetailStyles.reactmarkdownProjectIntro}
                remarkPlugins={[gfm, remarkMath]}
                rehypePlugins={[rehypeHighlight, rehypeKatex, rehypeRaw]}
              >
                {project?.description}
              </ReactMarkdown>
              
            </div>
          
          </div>
          <div id="menu" className={projectDetailStyles.menu}>
          <div style={{marginBottom: 24, display:'flex', }}>
            <div style={{display:'flex', height:30, marginRight:16,padding:0, width:30}} className={projectDetailStyles.aimHeaderLogoDiv}>  
                    <MenuIcon />
                    </div> 
            
            
              <span style={{fontSize: 24, lineHeight:'30px', fontWeight:700, color:'#1f2937'}}>实训大纲</span>
            </div>
            <div className={projectDetailStyles.menuTree}>       
              {openkeys && project?.menu && constructMenu()} 
            </div>
          </div>

          

          <Modal
            title={
              <div
                style={{ width: '100%', cursor: 'move', color: '#333' }}
                onMouseOver={() => {
                  if (disabled) {
                    setDisabled(false)
                  }
                }}
                onMouseOut={() => {
                  setDisabled(true)
                }}
                onFocus={() => {}}
                onBlur={() => {}}
              >
                提示
              </div>
            }
            width={350}
            className={projectStyles.whiteModal}
            closable={false}
            centered={true}
            open={notPurchasedVisible}
            bodyStyle={{ height: 80 }}
            footer={
              <div>
                <Button
                  className={projectStyles.stepsBtn}
                  style={{
                    marginRight: 20,
                    backgroundColor: '#f2f2f2',
                    border: 0,
                  }}
                  onClick={() => {
                    setNotPurchasedVisible(false)
                  }}
                >
                  取消
                </Button>
                <Button
                  className={projectStyles.stepsBtn}
                  style={{ marginRight: 20, color: '#fff' }}
                  type="primary"
                  onClick={() => {
                    setNotPurchasedVisible(false)
                    if (project?.access_info?.show_personal_pay_cta == 1) {
                      setCoursePaymentVisible(true)
                    }
                  }}
                >
                  个人付费
                </Button>
              </div>
            }
            modalRender={(modal) => (
              <div>
                <Draggable
                  disabled={disabled}
                  bounds={bounds}
                  onStart={(event, uiData) => onStart(event, uiData)}
                >
                  <div ref={draggleRef}>{modal}</div>
                </Draggable>{' '}
              </div>
            )}
          >
            <div style={{ width: 300, textAlign: 'center', color: '#333' }}>
              {accessPromptMessage || '你可以联系机构管理员/工作人员开通，或个人付费继续使用。'}
              <div style={{ color: '#4f46e5', marginTop: 6 }}>
                联系电话：{salesContact}
              </div>
            </div>
          </Modal>

          <Modal
            title={
              <div
                style={{ width: '100%', cursor: 'move', color: '#333' }}
                onMouseOver={() => {
                  if (disabled) {
                    setDisabled(false)
                  }
                }}
                onMouseOut={() => {
                  setDisabled(true)
                }}
                onFocus={() => {}}
                onBlur={() => {}}
              >
                提示
              </div>
            }
            width={350}
            className={projectStyles.whiteModal}
            closable={false}
            centered={true}
            open={delayVisible}
            bodyStyle={{ height: 80 }}
            footer={
              <div>
                <Button
                  className={projectStyles.stepsBtn}
                  style={{
                    marginRight: 20,
                    backgroundColor: '#f2f2f2',
                    border: 0,
                  }}
                  onClick={() => {
                    setDelayVisible(false)
                  }}
                >
                  取消
                </Button>
                <Button
                  className={projectStyles.stepsBtn}
                  style={{ marginRight: 20, color: '#fff' }}
                  type="primary"
                  onClick={() => {
                    setDelayVisible(false)
                    if (project?.access_info?.show_personal_pay_cta == 1) {
                      setCoursePaymentVisible(true)
                    }
                  }}
                >
                  个人付费
                </Button>
              </div>
            }
            modalRender={(modal) => (
              <div>
                <Draggable
                  disabled={disabled}
                  bounds={bounds}
                  onStart={(event, uiData) => onStart(event, uiData)}
                >
                  <div ref={draggleRef}>{modal}</div>
                </Draggable>{' '}
              </div>
            )}
          >
            <div style={{ width: 300, textAlign: 'center', color: '#333' }}>
              {accessPromptMessage || '机构授权已过期，可联系销售续约机构，或个人付费继续使用。'}
              <div style={{ color: '#4f46e5', marginTop: 6 }}>
                联系电话：{salesContact}
              </div>
            </div>
          </Modal>

          <CoursePaymentModal
            visible={coursePaymentVisible}
            courseId={projectId}
            priceCent={project?.access_info?.price_cent}
            onSuccess={onCoursePaymentSuccess}
            onCancel={() => {
              setCoursePaymentVisible(false)
            }}
          />

          <Modal
            title={
              <div
                style={{ width: '100%', cursor: 'move', color: '#333' }}
                onMouseOver={() => {
                  if (disabled) {
                    setDisabled(false)
                  }
                }}
                onMouseOut={() => {
                  setDisabled(true)
                }}
                onFocus={() => {}}
                onBlur={() => {}}
              >
                提示
              </div>
            }
            width={350}
            className={projectStyles.whiteModal}
            closable={false}
            centered={true}
            open={notOnlineVisible}
            bodyStyle={{ height: 80 }}
            footer={
              <div>
                <Button
                  className={projectStyles.stepsBtn}
                  style={{
                    marginRight: 20,
                    backgroundColor: '#f2f2f2',
                    border: 0,
                  }}
                  onClick={() => {
                    setNotOnlineVisible(false)
                  }}
                >
                  取消
                </Button>
                <Button
                  className={projectStyles.stepsBtn}
                  style={{ marginRight: 20, color: '#fff' }}
                  type="primary"
                  onClick={() => {
                    setNotOnlineVisible(false)
                  }}
                >
                  确认
                </Button>
              </div>
            }
            modalRender={(modal) => (
              <div>
                <Draggable
                  disabled={disabled}
                  bounds={bounds}
                  onStart={(event, uiData) => onStart(event, uiData)}
                >
                  <div ref={draggleRef}>{modal}</div>
                </Draggable>{' '}
              </div>
            )}
          >
            <div
              style={{
                width: 300,
                textAlign: 'center',
                color: '#333',
                marginTop: 10,
              }}
            >
              打造中，敬请期待~
            </div>
          </Modal>

          <Modal
            title={
              <div
                style={{ width: '100%', cursor: 'move', color: '#333' }}
                onMouseOver={() => {
                  if (disabled) {
                    setDisabled(false)
                  }
                }}
                onMouseOut={() => {
                  setDisabled(true)
                }}
                onFocus={() => {}}
                onBlur={() => {}}
              >
                <BulbOutlined style={{ marginRight: 5 }} />
                尊敬的用户您好，您还未加入所在院校。
              </div>
            }
            width={600}
            className={projectStyles.whiteModal}
            closable={true}
            onCancel={() => {
              setJoinVisible(false)
            }}
            centered={true}
            visible={joinVisible}
            bodyStyle={{ height: 380 }}
            footer={
              <div
                style={{ textAlign: 'center', height: '100%', paddingTop: 10 }}
              >
                {current > 0 && current < steps.length - 1 && (
                  <Button
                    className={projectStyles.stepsBtn}
                    style={{ color: '#4f46e5', marginRight: 50 }}
                    onClick={() => {
                      setCurrent(current - 1)
                    }}
                  >
                    上一步
                  </Button>
                )}
                {current < steps.length - 1 && (
                  <Button
                    className={projectStyles.stepsBtn}
                    style={{ color: '#4f46e5' }}
                    onClick={() => {
                      setCurrent(current + 1)
                    }}
                  >
                    下一步
                  </Button>
                )}
                {current == steps.length - 1 && (
                  <Button
                    className={projectStyles.stepsBtn}
                    style={{ color: '#4f46e5', padding: 0, marginRight: 50 }}
                    onClick={() => {
                      setCurrent(0)
                    }}
                  >
                    重新观看
                  </Button>
                )}
                {current == steps.length - 1 && (
                  <Button
                    className={projectStyles.stepsBtn}
                    style={{ color: '#fff', padding: 0 }}
                    type="primary"
                    onClick={() => {
                      setJoinVisible(false)
                    }}
                  >
                    我已了解
                  </Button>
                )}
              </div>
            }
            modalRender={(modal) => (
              <div>
                <Draggable
                  disabled={disabled}
                  bounds={bounds}
                  onStart={(event, uiData) => onStart(event, uiData)}
                >
                  <div ref={draggleRef}>{modal}</div>
                </Draggable>{' '}
              </div>
            )}
          >
            <div style={{ marginBottom: 10, color: '#000', marginLeft: 10 }}>
              加入院校方法如下：
            </div>
            <Steps
              size="small"
              labelPlacement="vertical"
              current={current}
              style={{ marginTop: 0 }}
            >
              {steps.map((item) => (
                <Step key={item.title} title={item.title} />
              ))}
            </Steps>
            <div>{steps[current].content}</div>
          </Modal>
            {/** 
          <Modal
            title={
              <div
                style={{ color: '#666', cursor: 'move' }}
                onMouseOver={() => {
                  if (disabled) {
                    setDisabled(false)
                  }
                }}
                onMouseOut={() => {
                  setDisabled(true)
                }}
                onFocus={() => {}}
                onBlur={() => {}}
              >
                请加入班级
                <Input
                  placeholder="ID/名称/老师"
                  suffix={<SearchOutlined style={{ color: '#666666' }} />}
                  onChange={(e) => {
                    queryClassRoom.current = e.target.value
                  }}
                  onPressEnter={(e) => {
                    queryProjectClassRoomList(
                      projectId,
                      collegeId,
                      false
                    )
                  }}
                />
              </div>
            }
            width={800}
            closable={false}
            centered={true}
            open={inClassVisible}
            bodyStyle={{ height: 450 }}
            className={projectStyles.chooseClassRoomDiv}
            footer={
              <div>
                <Pagination
                  style={{ float: 'left' }}
                  defaultCurrent={1}
                  total={resultSumClassRoom}
                  defaultPageSize={9}
                  current={pageClassRoom.current}
                  hideOnSinglePage={true}
                  onChange={onClassRoomPageChange}
                />

                <Button
                  className={projectStyles.stepsBtn}
                  style={{ marginRight: 20, color: '#fff', float: 'right' }}
                  type="primary"
                  onClick={() => {
                    setInputClassPasswordModalVisible(true)
                  }}
                >
                  确认
                </Button>
                <Button
                  className={projectStyles.stepsBtn}
                  style={{
                    marginRight: 20,
                    backgroundColor: '#f2f2f2',
                    border: 0,
                    float: 'right',
                  }}
                  onClick={() => {
                    setInClassVisible(false)
                  }}
                >
                  取消
                </Button>
              </div>
            }
            modalRender={(modal) => (
              <div>
                <Draggable
                  disabled={disabled}
                  bounds={bounds}
                  onStart={(event, uiData) => onStart(event, uiData)}
                >
                  <div ref={draggleRef}>{modal}</div>
                </Draggable>{' '}
              </div>
            )}
          >
            {projectClassRoomList?.length != 0 ? (
              <Radio.Group
                buttonStyle="solid"
                onChange={(e: any) => {
                  selectedClassRoomId.current = e.target.value.id
                  setSelectedClassRoom(e.target.value)
                }}
              >
                {projectClassRoomList?.map((class_) => {
                  return (
                    <Radio.Button key={class_.id} value={class_}>
                      <div className={projectStyles.classList}>
                        <div className={projectStyles.classId}>{class_.id}</div>
                        <div style={{ fontSize: 16 }}>{class_.name}</div>
                        <div
                          style={{
                            marginTop: 10,
                            paddingLeft: 40,
                            textAlign: 'left',
                            fontSize: 12,
                            opacity: 0.8,
                          }}
                        >
                          老师：
                          {class_?.teacher_real_name == ''
                            ? class_?.teacher_name
                            : class_?.teacher_real_name}
                        </div>
                        <div
                          style={{
                            paddingLeft: 40,
                            textAlign: 'left',
                            fontSize: 12,
                            opacity: 0.8,
                          }}
                        >
                          班号：{class_.number}
                        </div>
                      </div>
                    </Radio.Button>
                  )
                })}
              </Radio.Group>
            ) : (
              <div
                style={{ width: '100%', textAlign: 'center', color: '#ccc' }}
              >
                <img
                  src={classempty}
                  alt=""
                  width={200}
                  height={200}
                  style={{ margin: '40px auto' }}
                />
                <p>老师还未创建班级哦，请联系老师~</p>
              </div>
            )}
          </Modal>

          <Modal
            title={
              <div
                style={{ color: '#666', cursor: 'move' }}
                onMouseOver={() => {
                  if (disabled) {
                    setDisabled(false)
                  }
                }}
                onMouseOut={() => {
                  setDisabled(true)
                }}
                onFocus={() => {}}
                onBlur={() => {}}
              >
                加入班级:{selectedClassRoom?.name}
              </div>
            }
            width={260}
            closable={false}
            centered={true}
            open={inputClassPasswordModalVisible}
            bodyStyle={{
              padding: '0px 10px 0px 10px',
              textAlign: 'center',
              height: 100,
            }}
            className={projectStyles.chooseClassRoomDiv}
            footer={
              <div>
                <Button
                  className={projectStyles.stepsBtn}
                  style={{ marginRight: 20, color: '#fff', float: 'right' }}
                  type="primary"
                  onClick={onConfirmInputClass}
                >
                  确认
                </Button>
                <Button
                  className={projectStyles.stepsBtn}
                  style={{
                    marginRight: 20,
                    backgroundColor: '#f2f2f2',
                    border: 0,
                    float: 'right',
                  }}
                  onClick={() => {
                    setInputClassPasswordModalVisible(false)
                  }}
                >
                  取消
                </Button>
              </div>
            }
            modalRender={(modal) => (
              <div>
                <Draggable
                  disabled={disabled}
                  bounds={bounds}
                  onStart={(event, uiData) => onStart(event, uiData)}
                >
                  <div ref={draggleRef}>{modal}</div>
                </Draggable>{' '}
              </div>
            )}
          >
            <Row gutter={[4, 4]} justify="end" style={{ marginBottom: 10 }}>
              <Col flex="50px" style={{ textAlign: 'right', color: '#333' }}>
                密码
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <Input
                  style={{ borderRadius: 3, width: 150 }}
                  onChange={(e) => {
                    inputClassRoomPassword.current = e.target.value
                  }}
                  placeholder="请输入班级密码"
                />{' '}
              </Col>
            </Row>

            <Row gutter={[4, 4]} justify="end" style={{ marginBottom: 10 }}>
              <Col flex="50px" style={{ textAlign: 'right', color: '#333' }}>
                姓名
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <Input
                  style={{ borderRadius: 3, width: 150 }}
                  value={realName}
                  onChange={(e) => {
                    setRealName(e.target.value)
                  }}
                  placeholder="请输入真实姓名"
                />{' '}
              </Col>
            </Row>

            <Row gutter={[4, 4]} justify="end" style={{ marginBottom: 10 }}>
              <Col flex="50px" style={{ textAlign: 'right', color: '#333' }}>
                学号
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <Input
                  value={realNumber}
                  style={{ borderRadius: 3, width: 150 }}
                  onChange={(e) => {
                    setRealNumber(e.target.value)
                  }}
                  placeholder="请输入学号"
                />{' '}
              </Col>
            </Row>
          </Modal>
          */}

                    <Modal
            title={
              <div
                style={{ width: '100%', cursor: 'move' }}
                onMouseOver={() => {
                  if (disabled) {
                    setDisabled(false)
                  }
                }}
                onMouseOut={() => {
                  setDisabled(true)
                }}
                onFocus={() => {}}
                onBlur={() => {}}
              >
                请选择班级
              </div>
            }
            width={916}
            closable={true}
            onCancel={()=>{setInClassVisible(false)}}
            centered={true}
            open={inClassVisible}
            bodyStyle={{ height: 610 }}
            className={projectStyles.changeClassModal}
            footer={
              <div>

                <Button
                  className={projectStyles.stepsBtn}
                  style={{ marginRight: 20 ,color:'#fff', background:'#4f46e5', borderColor:'#4f46e5'}}
                  type="primary"
                  onClick={() => {
                    setInputClassPasswordModalVisible(true)
                  }}
                >
                  确认选择
                </Button>
                <Button
                  className={projectStyles.stepsBtn}
                  style={{
                    marginRight: 20,
                    backgroundColor: 'rgba(250,250,250,.1)',
                    color: 'rgb(55 65 81)',
                    border: '1px solid rgb(209 213 219)',
                    //float: 'right',
                  }}
                  onClick={() => {
                    setInClassVisible(false)
                  }}
                >
                  取消
                </Button>
              </div>
            }
            modalRender={(modal) => (
              <div>
                <Draggable
                  disabled={disabled}
                  bounds={bounds}
                  onStart={(event, uiData) => onStart(event, uiData)}
                >
                  <div ref={draggleRef}>{modal}</div>
                </Draggable>{' '}
              </div>
            )}
          >

              <Input
                  placeholder="ID/名称/老师"
                  suffix={<SearchOutlined style={{ color: '#666666' }} />}
                  onChange={(e) => {
                    queryClassRoom.current  = e.target.value
                  }}
                  onPressEnter={(e) => {
                    pageClassRoom.current =1; queryProjectClassRoomList( projectId, collegeId, false)
                  }}
                  style={{fontSize:16,padding:'12px 16px 12px 16px', borderRadius:8,margin:'0 24px 24px 10px', width:'calc(100% - 34px)'}}
                />

            {projectClassRoomList?.length != 0 ? (
              <div><Radio.Group
                buttonStyle="solid"
                onChange={(e: any) => {
                  selectedClassRoomId.current = e.target.value.id
                  setSelectedClassRoom(e.target.value)
                }}
              >
                {projectClassRoomList?.map((class_) => {
                  return (
                    <Radio.Button
                      key={class_.id}
                      value={class_}
                     
                    >
                      <div className={projectStyles.changeClassList}>
                        <div style={{height:25}}>
                        { selectedClassRoomId.current ==class_.id && <div className={projectStyles.changeClassCheckedIcon}><CheckCircleOutlined style={{color:'#4f46e5'}} /></div>}
      
                        </div>
                        <div style={{ fontSize: 18, fontWeight:600, marginBottom:4 }}>{class_.name}</div>
                        <div style={{fontSize:14, marginBottom:16, color:'rgb(107 114 128)'}}>班号： {class_.number}</div>

                        <Row wrap={false} gutter={16} align={'middle'} style={{marginBottom:16}}>
                                    <Col flex={'40px'} >
                                        <div style={{borderRadius:'50%',height:40, width:40}}>
                                            <img  src={ class_?.teacher_avatar?.startsWith("http") ? class_?.teacher_avatar : BACKEND_API_URL + class_?.teacher_avatar}  style={{borderRadius:'50%', width:40,height:40}}/>   
                                        </div>     
                                    </Col>

                                    <Col flex={'auto'}>
                                        <div style={{marginLeft:12}}>
                                            <div style={{fontSize:16, fontWeight:600, color:'#1f2937'}}>{class_?.teacher_real_name?class_?.teacher_real_name:class_?.user_name}</div>
                                        </div>     
                                    </Col>
                        </Row>


                        <div>
                        <TeamOutlined  style={{marginRight:6}}/> 现有学员: {class_?.user_count} 人
                        </div>

                      </div>
                    </Radio.Button>
                  )
                })}
              </Radio.Group>

                <div style={{textAlign:'center'}}>
                  <ConfigProvider locale={zhCN}> 
                    <Pagination
                      //style={{ float: 'left' }}
                      defaultCurrent={1}
                      total={resultSumClassRoom}
                      pageSize={6}
                      current={pageClassRoom.current}
                      hideOnSinglePage={true}
                      onChange={onClassRoomPageChange}
                      showSizeChanger={false}
                      
                    />
                  </ConfigProvider>
                </div>

              
              </div>
            ) : (
              <div style={{ width: '100%', textAlign: 'center', color: '#ccc' }}>
                <img
                  src={classempty}
                  alt=""
                  width={200}
                  height={200}
                  style={{ margin: '40px auto' }}
                />
                <p>你所在机构老师还未创建班级哦，请联系老师创建后使用~</p>
              </div>
            )}
          </Modal>

          <Modal
            title={
              <div
                style={{ width: '100%', cursor: 'move', color: '#666' }}
                onMouseOver={() => {
                  if (disabled) {
                    setDisabled(false)
                  }
                }}
                onMouseOut={() => {
                  setDisabled(true)
                }}
                onFocus={() => {}}
                onBlur={() => {}}
              >
                加入班级:{selectedClassRoom?.name}
              </div>
            }
            width={420}
            closable={false}
            centered={true}
            open={inputClassPasswordModalVisible}
            bodyStyle={{
              padding: '20px 28px 4px',
              textAlign: 'left',
            }}
            className={projectStyles.chooseClassRoomDiv}
            footer={
              <div style={{ display: 'flex', justifyContent: 'center', gap: 12 }}>
                <Button
                  className={projectStyles.stepsBtn}
                  style={{ color: '#fff' }}
                  type="primary"
                  onClick={onConfirmInputClass}
                >
                  确认
                </Button>
                <Button
                  className={projectStyles.stepsBtn}
                  style={{
                    backgroundColor: '#f1f5f9',
                    border: 0,
                    color: '#475569',
                  }}
                  onClick={() => {
                    setJoinClassError('')
                    setInputClassPasswordModalVisible(false)
                  }}
                >
                  取消
                </Button>
              </div>
            }
            modalRender={(modal) => (
              <div>
                <Draggable
                  disabled={disabled}
                  bounds={bounds}
                  onStart={(event, uiData) => onStart(event, uiData)}
                >
                  <div ref={draggleRef}>{modal}</div>
                </Draggable>{' '}
              </div>
            )}
          >
            {joinClassError && (
              <div className={projectStyles.joinClassErrorMsg}>{joinClassError}</div>
            )}
            <div className={projectStyles.joinClassFormItem}>
              <label className={projectStyles.joinClassFormLabel}>班级密码</label>
              <Input
                onChange={(e) => {
                  inputClassRoomPassword.current = e.target.value
                }}
                placeholder="请输入班级密码"
              />
            </div>
            <div className={projectStyles.joinClassFormItem}>
              <label className={projectStyles.joinClassFormLabel}>真实姓名</label>
              <Input
                value={realName}
                onChange={(e) => {
                  setRealName(e.target.value)
                }}
                placeholder="请输入真实姓名"
              />
            </div>
            <div className={projectStyles.joinClassFormItem}>
              <label className={projectStyles.joinClassFormLabel}>学号</label>
              <Input
                value={realNumber}
                onChange={(e) => {
                  setRealNumber(e.target.value)
                }}
                placeholder="请输入学号"
              />
            </div>
          </Modal>


        </div>
      </div>


      <PageFooter />
      
    </Layout>
  )
  
}

export default ProjectDetail
